import { ComponentProps } from "react";
import { BlockTitle } from "@app/blocks/Blocks";
import Card from "@particles/card/Card";
import CompaniesMarketsStories from "@routes/Home/CompaniesMarkets/CompaniesMarketsStories";
import { sectionNavigationItems } from "@util/constant";
import { cn } from "@util/helpers";

type CompaniesMarketsProps = {
  /** Test id for the component */
  testId?: string | null;
  /** Additionl styling for the component */
  className?: string;
  /** The list of the article card props */
  cardProps: ComponentProps<typeof Card>[];
};

const section = sectionNavigationItems["companies-markets"];

/**
 * Renders the Home - companies and markets section with a title and a list of articles.
 * https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1312-2073&t=g7P8QlYHW3Ymfii6-4
 */
const CompaniesMarkets = ({
  className,
  cardProps,
}: CompaniesMarketsProps): React.ReactElement => {
  return (
    <section
      className={className}
      data-testid="homepage-companies-market-stories-component"
    >
      <BlockTitle
        link={section?.link}
        text={section?.label?.toUpperCase() ?? ""}
      />

      <div
        className={cn(
          "stories lg:grid lg:grid-flow-col lg:grid-cols-2 lg:grid-rows-3"
        )}
      >
        {cardProps.map((card, index) => {
          return (
            <CompaniesMarketsStories
              cardProps={card}
              index={index}
              key={card.id}
            />
          );
        })}
      </div>
    </section>
  );
};

export default CompaniesMarkets;
